import React from 'react'

export default function Footer() {
  return (
    <>

<footer className="bg-dark text-center text-white">
        <div className="container p-4 pb-0">
            <section className="mb-4">
                <a className="btn btn-outline-light btn-floating m-1" target="_blank" href="https://www.facebook.com/Honey.Ahmed.Mohamed">
                    <i className="fab fa-facebook-f"></i></a>

                <a className="btn btn-outline-light btn-floating m-1" target="_blank" href="https://twitter.com/HoneyAhmedM?fbclid=IwAR2DAaHpa7XbpoZ26czaZjrzgwNpJERMI40JjNEpVZwWwYacqgssd80DOo4"><i className="fab fa-twitter"></i
                    ></a>

                <a className="btn btn-outline-light btn-floating m-1" target="_blank" href="https://www.instagram.com/honeyahmedm/?fbclid=IwAR2y-S92QvmZmuZ5gTGXEAUt34EgWHyMqo7lD1wkleB58BsFb5YjfyGbf70"><i className="fab fa-instagram"></i
                    ></a>

                <a className="btn btn-outline-light btn-floating m-1" target="_blank" href="https://www.linkedin.com/in/honey-ahmed-006801187/"><i className="fab fa-linkedin-in"></i
                    ></a>

                <a className="btn btn-outline-light btn-floating m-1" target="_blank" href="https://github.com/honeyahmed"><i className="fab fa-github"></i
                    ></a>
            </section>
        </div>

        <div className="text-center p-3" style={{backgroundColor:"RGB(20, 20, 20)"}}>
            Made in 2022 :
            <a className="text-white" href="mailto:honeyahmed77@gmail.com">Contact me ;) </a>
        </div>
    </footer>
    </>
  )}

